import { format, InputMask } from "@react-input/mask";
import React, { useEffect, useState, useCallback } from "react";

interface Props {
  id: string;
  label: string;
  value: string;
  setCustomerData: (data: Record<string, any>) => void;
  setIsInvalid?: any;
  className?: string;
  idCnpj?:any
}

const CellPhone: React.FC<Props> = ({ id, label, value, setCustomerData, className, setIsInvalid,idCnpj }) => {
  const [maskedValue, setMaskedValue] = useState("");
  const [valueClean, setValueClean] = useState("");

  const formatPhoneNumber = (phone: string) =>
    format(phone, { mask: "(__) ____-____", replacement: { _: /\d/ } });

  const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const cleanValue = event.target.value.replace(/\D/g, "");
    setValueClean(cleanValue);

    setCustomerData((prevForm: Record<string, any>) => ({
      ...prevForm,
      [id]: cleanValue,
    }));

    setIsInvalid?.((prevForm: any) => ({
      ...prevForm,
      [id]: false,
    }));

    setMaskedValue(formatPhoneNumber(cleanValue));
  }, [id, setCustomerData, setIsInvalid]);

  const handleBlur = useCallback(() => {
    if (valueClean.length !== 10) {
      setIsInvalid?.((prevForm: any) => ({
        ...prevForm,
        [id]: true,
      }));
    }
  }, [id, valueClean, setIsInvalid]);

  useEffect(() => {
    if (value) {
      const cleanValue = value.replace(/\D/g, "");
      setValueClean(cleanValue);
      setMaskedValue(formatPhoneNumber(cleanValue));
    }
  }, [value]);

  return (
    <div>
      <label htmlFor={id}>{label}</label>
      <InputMask
        id={id}
        value={maskedValue}
        onChange={handleChange}
        onBlur={handleBlur}
        mask="(__) ____-____"
        placeholder="(00) 0000-0000"
        replacement={{ _: /\d/ }}
        className={className}
        disabled={idCnpj ? true : false}
      />
      {setIsInvalid && <p className="invalid-feedback">Insira um N° de {label} válido</p>}
    </div>
  );
};

export default CellPhone;
